import { ResultError } from './ResultError.js';
class Err {
    constructor(error) {
        this.error = error;
    }
    get isOk() {
        return false;
    }
    get isErr() {
        return true;
    }
    get value() {
        return ResultError.raise(this, 'ERR_NOT_OK', 'Cannot access `value` on an Err instance.', Object.getOwnPropertyDescriptor(Err.prototype, 'value').get);
    }
    map() {
        return this;
    }
    mapErr(fn) {
        return new Err(fn(this.error));
    }
    chain() {
        return this;
    }
    chainErr(next) {
        return next(this.error);
    }
    unwrap() {
        return ResultError.raise(this, 'ERR_NOT_OK', 'Cannot `unwrap` an Err instance.', Object.getOwnPropertyDescriptor(Err.prototype, 'unwrap').get);
    }
    unwrapOr(fallback) {
        return fallback;
    }
    unwrapOrElse(fallback) {
        return fallback(this.error);
    }
    unwrapErr() {
        return this.error;
    }
    unwrapErrOr() {
        return this.error;
    }
    unwrapErrOrElse() {
        return this.error;
    }
    unpack() {
        return this.error;
    }
    match(okMatcher, errMatcher) {
        return errMatcher(this.error);
    }
    tap() {
        return this;
    }
    tapErr(fn) {
        fn(this.error);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.error;
        return undefined;
    }
    unwrapOrThrow() {
        throw this.error;
    }
    biMap(_, errFn) {
        return this.mapErr(errFn);
    }
    biChain(_, errFn) {
        return errFn(this.error);
    }
    asTuple() {
        return [false, this.error, undefined];
    }
    get [Symbol.toStringTag]() {
        return 'Err';
    }
}
Object.setPrototypeOf(Err.prototype, null);
Object.defineProperty(Err, 'name', {
    value: 'Err',
    writable: false,
    enumerable: false,
    configurable: false,
});
export const ErrImpl = Err;
export const err = (error) => new Err(error);
export const asyncErr = async (error) => err(await error);
